import $ from 'jquery';

import ('./scss/blocks/query-slick.scss');
import 'slick-carousel';

export function Slick() {
	const defaultConfig = {
		dots: true,
		centerMode: false,
		centerPadding: '60px',
		slidesToShow: 3,
		arrows: true,
		responsive: [
			{
				breakpoint: 1224,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
					infinite: true,
				}
			},
			{
				breakpoint: 800,
				settings: {
					dots: false,
					slidesToShow: 1,
					slidesToScroll: 1,
					centerMode: true,
					centerPadding: '60px',
					fade: true,
					cssEase: 'linear'
				}
			}
		]
	};

	// Award configuration
	const awardConfig = {
		slidesToShow: 6,
		arrows: true,
		responsive: [
			{
				breakpoint: 1224,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
					infinite: true,
					dots: true
				}
			},
			{
				breakpoint: 800,
				settings: {
					dots: false,
					slidesToShow: 1,
					slidesToScroll: 1,
					fade: true,
					cssEase: 'linear'
				}
			}
			// You can unslick at a given breakpoint now by adding:
			// settings: "unslick"
			// instead of a settings object
		]
	};
	// $('.portfolio-gallery-block').css('opacity', '1');
	// These two are for the portfolio galleries
	// Main image, wait for load before initializing
	// $('.portfolio-featured-image img:first').load(function () {
		// Delay before initializing slick on .portfolio-featured-image
		setTimeout(function () {
			// On iOS, the slick slider doesn't initialize properly unless it's delayed
			// https://stackoverflow.com/questions/37949981/slick-slider-not-working-on-ios
			$('.portfolio-featured-image').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false,
				fade: false,
				responsive: [
					{
						breakpoint: 800,
						settings: {
							arrows: true,
							dots: true,
							slidesToShow: 1,
							slidesToScroll: 1,
							fade: true,
							cssEase: 'linear'
						}
					}
				]
			});

			$('.portfolio-gallery-nav').slick({
				slidesToShow: 4,
				slidesToScroll: 1,
				asNavFor: '.portfolio-featured-image',
				focusOnSelect: true,
				arrows: true,
				responsive: [
					{
						breakpoint: 1100,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 1,
							infinite: true,
							dots: true
						}
					},
					{
						breakpoint: 1300,
						settings: {
							slidesToShow: 3,
							slidesToScroll: 1,
							infinite: true,
							dots: true
						}
					}
				]
			});
			// set opacity of .portfolio-gallery-block to 1
			$('.portfolio-gallery-block').css('opacity', '1');
		}, 1500);
	// });


	// This is the query for the ACF field that shows what's new
	$('.featured-posts-block.is-style-lb-slick ul').slick({
		dots: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		fade: true,
		cssEase: 'linear'
	});
	// The testimonial slider block
	$('.testimonial-posts.is-style-lb-slick').slick({
		dots: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		fade: true,
		cssEase: 'linear',
		adaptiveHeight: true
	});

	// Slick on the home page awards
	$('.is-style-lb-slick-small').slick(awardConfig);

	// Slick on the home page
	// $('.slidesToShow-six.is-style-lb-slick').slick({
	// 	dots: true,
	// 	slidesToShow: 6,
	// 	arrows: true,
	// 	responsive: [
	// 		{
	// 			breakpoint: 1224,
	// 			settings: {
	// 				slidesToShow: 3,
	// 				slidesToScroll: 3,
	// 				infinite: true,
	// 				dots: true
	// 			}
	// 		},
	// 		{
	// 			breakpoint: 600,
	// 			settings: {
	// 				dots: false,
	// 				slidesToShow: 1,
	// 				slidesToScroll: 1,
	// 				fade: true,
	// 				cssEase: 'linear'
	// 			}
	// 		}
	// 		// You can unslick at a given breakpoint now by adding:
	// 		// settings: "unslick"
	// 		// instead of a settings object
	// 	]
	// });

	// Home page roofing types list
	$('.roof-types div.is-style-lb-slick:not(.facetwp-template)').slick(defaultConfig);

	// subpage portfolio
	$('.roofing-projects.wp-block-query:not(.facetwp-template) ul').slick(defaultConfig);

	// This is the subpage portfolio slider block
	// $('.is-style-lb-slick.multiple-items:not(.facetwp-template) ul').slick(defaultConfig);

	// FacetWP needs to be initialized before it will work:

	// Attach facet-wp events
	$(document).on('facetwp-loaded', function () {
		$('.facetwp-template.is-style-lb-slick.multiple-items ul').slick(defaultConfig);
	});


	console.log('slick init complete');
}
